import Action from "../actions";
import Time from "../../main/createtime";
import {
  setMessages,
  updateForVideo,
  setNotifyNumber,
  setTitle,
  setUser,
  handelSuggest,
  reobject,
} from "../helper";
//npx browserslist@latest --update-db
//rm -rf node_modules && npm install && rm -rf /tmp/metro-* && npm run start --reset-cache
/////////////////////////////////////////
const handlePopup = (action, name, newState) => {
  if (action.peyload) newState.store.popup[name] = name;
  else delete newState.store.popup[name];
};
const genrateRandom = Math.random().toString(36).substr(2, 9);
export const userInit = {
  Address: "",
  JoinedDate: "",
  isApp: false,
  Phone: "",
  UserPhoto: "https://cdn.meetoor.com/media/media/DefaultPhotos/defult.png",
  email: "meetoor@gmail.com",
  first_name: "anony",
  fullName: `meetoor_user_${genrateRandom}`,
  last_name: "user",
  status: true,
  userid: `id_${genrateRandom}`,
  username: `user_${genrateRandom}`,
};
const version = "1.8.9";
////////////////////////////////////////
const initState = {
  store: {
    popup: {},
  },
  title: "meetoor™",
  time: Time,
  scrollsPosition: {},
  suggestFriends: undefined,
  suggestFriendsHasNextPage: false,
  suggestFriendsEndCursor: null,
  requestFriends: undefined,
  requestFriendsHasNextPage: false,
  requestFriendsEndCursor: null,
  requestTeams: undefined,
  requestTeamsHasNextPage: false,
  requestTeamsEndCursor: null,
  suggestTeams: undefined,
  suggestTeamsHasNextPage: false,
  suggestTeamsEndCursor: null,
  receivedFriends: undefined,
  receivedFriendsHasNextPage: false,
  receivedFriendsEndCursor: null,
  receivedTeams: undefined,
  toggleLeft: false,
  messages: [],
  chatUsers: undefined,
  messageNumber: 0,
  enableEmoji: false,
  allVideos: [],
  version,
  info: {
    href: "/home/profile/?p=devi",
    name: "Dev Ahmad Hassan",
    head: "meetoor developer",
    ver: `meetoor™ v ${version}`,
  },
  apiUrl: "https://meetoor.com",
  cdnUrl: "https://cdn.meetoor.com",
  message: "",
  GoToTop: 27,
  user: userInit,
  // `myAccountVerification`: what the account has proved (e-mail, phone) and how it signs in.
  verification: undefined,
  teamsUser: undefined,
  teamsUserHasNextPage: false,
  teamsUserEndCursor: null,
  teamsJoin: undefined,
  teamsJoinHasNextPage: false,
  teamsJoinEndCursor: null,
  friendsUser: undefined,
  friendsUserHasNextPage: false,
  friendsUserEndCursor: null,
  anonyUsers: undefined,
  stickers: undefined,
  filter: false,
  renderLeft: true,
  popupControls: false,
  popupFloatWindow: false,
  popupFloatWindowTeam: false,
  itemTeamHumber: false,
  toggleSearch: false,
  itemMainHumber: false,
  popupUserWindow: false,
  popupChatWindow: false,
  popupNotifyWindow: false,
  popupMainWindow: false,
  popupImageWindow: false,
  popupCloseWindow: false,
  miniPopup: false,
  openMoreWin: false,
  replyWin: false,
  suggestFollowers: undefined,
  followings: undefined,
  followers: undefined,
  myStory: undefined,
  currentSeener: undefined,
  windowStatus: false,
  currentStories: [],
  currentStoriesHasNextPage: false,
  currentStoriesEndCursor: null,
};
////////////////////////////////////////
const reducer = (state = initState, action) => {
  const newState = state;
  switch (action.type) {
    /////////////////////////////////////
    case Action.setScrollsPosition:
      return {
        ...newState,
        scrollsPosition: {
          ...newState.scrollsPosition,
          [action.peyload.key]: action.peyload.value,
        },
      };
    /////////////////////////////////////
    case Action.setStickers:
      return {
        ...newState,
        stickers: action.peyload,
      };
    /////////////////////////////////////
    case Action.setGoToTop:
      return {
        ...newState,
        GoToTop: action.peyload,
      };
    /////////////////////////////////////
    case Action.setAnonyUsers:
      return {
        ...newState,
        anonyUsers: reobject(
          action.peyload.type,
          action.peyload.data,
          newState.anonyUsers
        ),
        // anonyUsers: { ...newState.anonyUsers, [action.peyload.key]: action.peyload.val }
      };
    /////////////////////////////////////
    case Action.setAllVideos:
      return {
        ...newState,
        allVideos: updateForVideo(
          action.peyload.type,
          action.peyload.data,
          action.peyload.callback,
          newState.allVideos
        ),
      };
    /////////////////////////////////////
    case Action.setFilter: //
      return {
        ...newState,
        filter: action.peyload,
        message: !action.peyload ? "" : newState.message,
      };
    /////////////////////////////////////
    case Action.setRenderLeft:
      return {
        ...newState,
        renderLeft: action.peyload,
      };
    /////////////////////////////////////
    case Action.setWindowStatus:
      handlePopup(action, "setWindowStatus", newState);
      return {
        ...newState,
        windowStatus: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupControls:
      handlePopup(action, "setPopupControls", newState);
      return {
        ...newState,
        popupControls: action.peyload,
      };
    /////////////////////////////////////
    case Action.setEnableEmoji:
      handlePopup(action, "setEnableEmoji", newState);
      return {
        ...newState,
        enableEmoji: action.peyload,
      };
    /////////////////////////////////////
    case Action.setOpenMoreWin:
      handlePopup(action, "setOpenMoreWin", newState);
      return {
        ...newState,
        openMoreWin: action.peyload,
      };
    /////////////////////////////////////
    case Action.setReplyWin:
      return {
        ...newState,
        replyWin: action.peyload,
      };
    /////////////////////////////////////
    case Action.setToggleSearch:
      handlePopup(action, "setToggleSearch", newState);
      return {
        ...newState,
        toggleSearch: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupFloatWindow:
      handlePopup(action, "setPopupFloatWindow", newState);
      return {
        ...newState,
        popupFloatWindow: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupFloatWindowTeam:
      handlePopup(action, "setPopupFloatWindowTeam", newState);
      return {
        ...newState,
        popupFloatWindowTeam: action.peyload,
      };
    /////////////////////////////////////
    case Action.setItemTeamHumber:
      handlePopup(action, "setItemTeamHumber", newState);
      return {
        ...newState,
        itemTeamHumber: action.peyload,
      };
    /////////////////////////////////////
    case Action.setItemMainHumber:
      handlePopup(action, "setItemMainHumber", newState);
      return {
        ...newState,
        itemMainHumber: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupChatWindow:
      handlePopup(action, "setPopupChatWindow", newState);
      return {
        ...newState,
        popupChatWindow: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupUserWindow:
      handlePopup(action, "setPopupUserWindow", newState);
      return {
        ...newState,
        popupUserWindow: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupNotifyWindow:
      handlePopup(action, "setPopupNotifyWindow", newState);
      return {
        ...newState,
        popupNotifyWindow: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupImage:
      handlePopup(action, "setPopupImage", newState);
      return {
        ...newState,
        popupImageWindow: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupClose:
      handlePopup(action, "setPopupClose", newState);
      return {
        ...newState,
        popupCloseWindow: action.peyload,
      };
    /////////////////////////////////////
    case Action.setPopupMain:
      handlePopup(action, "setPopupMain", newState);
      return {
        ...newState,
        popupMainWindow: action.peyload,
      };
    case Action.setPopupMini:
      handlePopup(action, "setPopupMini", newState);
      return {
        ...newState,
        miniPopup: action.peyload,
      };
    case Action.toggleWinFriends:
      handlePopup(action, "toggleWinFriends", newState);
      return {
        ...newState,
        toggleLeft: action.peyload,
      };
    case Action.setSuggestLoad:
      return {
        ...newState,
        suggestLoad: action.peyload,
      };
    case Action.setTitle:
      return {
        ...newState,
        title: setTitle(
          action.peyload.type,
          action.peyload.data,
          newState.title
        ),
      };
    ////////////////////////////////////
    case Action.setMessageNumber:
      return {
        ...newState,
        messageNumber: setNotifyNumber(
          action.peyload.type,
          action.peyload.data,
          newState.messageNumber
        ),
      };
    case Action.setMessages:
      return {
        ...newState,
        messages: setMessages(
          action.peyload.type,
          action.peyload.data,
          newState.messages
        ),
      };
    case Action.setChatUsers:
      return {
        ...newState,
        chatUsers: setMessages(
          action.peyload.type,
          action.peyload.data,
          newState.chatUsers
        ),
      };
    case Action.setReceivedFriends: {
      const nextReceived = handelSuggest(
        action.peyload.type,
        action.peyload.data,
        newState.receivedFriends
      );
      const piRf = action.peyload.pageInfo;
      let receivedFriendsHasNextPage = newState.receivedFriendsHasNextPage;
      let receivedFriendsEndCursor = newState.receivedFriendsEndCursor;
      if (action.peyload.type === "set") {
        if (piRf !== undefined && piRf !== null) {
          receivedFriendsHasNextPage = !!piRf.hasNextPage;
          receivedFriendsEndCursor = piRf.endCursor || null;
        } else {
          receivedFriendsHasNextPage = false;
          receivedFriendsEndCursor = null;
        }
      } else if (action.peyload.type === "push" && piRf) {
        receivedFriendsHasNextPage = !!piRf.hasNextPage;
        receivedFriendsEndCursor = piRf.endCursor || null;
      }
      return {
        ...newState,
        receivedFriends: nextReceived,
        receivedFriendsHasNextPage,
        receivedFriendsEndCursor,
      };
    }
    /////////////////////////////////////
    case Action.setReceivedTeams:
      return {
        ...newState,
        receivedTeams: handelSuggest(
          action.peyload.type,
          action.peyload.data,
          newState.receivedTeams
        ),
      };
    /////////////////////////////////////
    case Action.setRequestFriends: {
      const p = action.peyload;
      const nextReq = handelSuggest(
        p.type,
        p.data,
        newState.requestFriends
      );
      const pi = p.pageInfo;
      let requestFriendsHasNextPage = newState.requestFriendsHasNextPage;
      let requestFriendsEndCursor = newState.requestFriendsEndCursor;
      if (p.type === "set") {
        if (pi !== undefined && pi !== null) {
          requestFriendsHasNextPage = !!pi.hasNextPage;
          requestFriendsEndCursor = pi.endCursor || null;
        } else {
          requestFriendsHasNextPage = false;
          requestFriendsEndCursor = null;
        }
      } else if (p.type === "push" && pi) {
        requestFriendsHasNextPage = !!pi.hasNextPage;
        requestFriendsEndCursor = pi.endCursor || null;
      }
      return {
        ...newState,
        requestFriends: nextReq,
        requestFriendsHasNextPage,
        requestFriendsEndCursor,
      };
    }
    /////////////////////////////////////
    case Action.setRequestTeams: {
      const p = action.peyload;
      const nextTeams = handelSuggest(
        p.type,
        p.data,
        newState.requestTeams
      );
      const pi = p.pageInfo;
      let requestTeamsHasNextPage = newState.requestTeamsHasNextPage;
      let requestTeamsEndCursor = newState.requestTeamsEndCursor;
      if (p.type === "set") {
        if (pi !== undefined && pi !== null) {
          requestTeamsHasNextPage = !!pi.hasNextPage;
          requestTeamsEndCursor = pi.endCursor || null;
        } else {
          requestTeamsHasNextPage = false;
          requestTeamsEndCursor = null;
        }
      } else if (p.type === "push" && pi) {
        requestTeamsHasNextPage = !!pi.hasNextPage;
        requestTeamsEndCursor = pi.endCursor || null;
      }
      return {
        ...newState,
        requestTeams: nextTeams,
        requestTeamsHasNextPage,
        requestTeamsEndCursor,
      };
    }
    ////////////////////////////////////
    case Action.setMyStory:
      return {
        ...newState,
        myStory: setUser(
          action.peyload.type,
          action.peyload.data,
          newState.myStory
        ),
      };
    case Action.setCurrentStories: {
      const pcs = action.peyload;
      const nextStories = handelSuggest(
        pcs.type,
        pcs.data,
        newState.currentStories
      );
      const piCs = pcs.pageInfo;
      let currentStoriesHasNextPage = newState.currentStoriesHasNextPage;
      let currentStoriesEndCursor = newState.currentStoriesEndCursor;
      if (pcs.type === "set") {
        if (piCs !== undefined && piCs !== null) {
          currentStoriesHasNextPage = !!piCs.hasNextPage;
          currentStoriesEndCursor = piCs.endCursor || null;
        } else {
          currentStoriesHasNextPage = false;
          currentStoriesEndCursor = null;
        }
      } else if (pcs.type === "push" && piCs) {
        currentStoriesHasNextPage = !!piCs.hasNextPage;
        currentStoriesEndCursor = piCs.endCursor || null;
      }
      return {
        ...newState,
        currentStories: nextStories,
        currentStoriesHasNextPage,
        currentStoriesEndCursor,
      };
    }
    case Action.setCurrentSeener:
      return {
        ...newState,
        currentSeener: handelSuggest(
          action.peyload.type,
          action.peyload.data,
          newState.currentSeener
        ),
      };
    ////////////////////////////////////
    case Action.setSuggestTeams: {
      const pst = action.peyload;
      const nextSuggestTeams = handelSuggest(
        pst.type,
        pst.data,
        newState.suggestTeams
      );
      const piSt = pst.pageInfo;
      let suggestTeamsHasNextPage = newState.suggestTeamsHasNextPage;
      let suggestTeamsEndCursor = newState.suggestTeamsEndCursor;
      if (pst.type === "set") {
        if (piSt !== undefined && piSt !== null) {
          suggestTeamsHasNextPage = !!piSt.hasNextPage;
          suggestTeamsEndCursor = piSt.endCursor || null;
        } else {
          suggestTeamsHasNextPage = false;
          suggestTeamsEndCursor = null;
        }
      } else if (pst.type === "push" && piSt) {
        suggestTeamsHasNextPage = !!piSt.hasNextPage;
        suggestTeamsEndCursor = piSt.endCursor || null;
      }
      return {
        ...newState,
        suggestTeams: nextSuggestTeams,
        suggestTeamsHasNextPage,
        suggestTeamsEndCursor,
      };
    }
    case Action.setSuggestFriends: {
      const psf = action.peyload;
      const nextSuggestFriends = handelSuggest(
        psf.type,
        psf.data,
        newState.suggestFriends
      );
      const piSf = psf.pageInfo;
      let suggestFriendsHasNextPage = newState.suggestFriendsHasNextPage;
      let suggestFriendsEndCursor = newState.suggestFriendsEndCursor;
      if (psf.type === "set") {
        if (piSf !== undefined && piSf !== null) {
          suggestFriendsHasNextPage = !!piSf.hasNextPage;
          suggestFriendsEndCursor = piSf.endCursor || null;
        } else {
          suggestFriendsHasNextPage = false;
          suggestFriendsEndCursor = null;
        }
      } else if (psf.type === "push" && piSf) {
        suggestFriendsHasNextPage = !!piSf.hasNextPage;
        suggestFriendsEndCursor = piSf.endCursor || null;
      }
      return {
        ...newState,
        suggestFriends: nextSuggestFriends,
        suggestFriendsHasNextPage,
        suggestFriendsEndCursor,
      };
    }

    case Action.setFollowers:
      return {
        ...newState,
        followers: handelSuggest(
          action.peyload.type,
          action.peyload.data,
          newState.followers
        ),
      };
    case Action.setFollowing:
      return {
        ...newState,
        followings: handelSuggest(
          action.peyload.type,
          action.peyload.data,
          newState.followings
        ),
      };
    case Action.setSuggestFollowers:
      return {
        ...newState,
        suggestFollowers: handelSuggest(
          action.peyload.type,
          action.peyload.data,
          newState.suggestFollowers
        ),
      };

    case Action.setTeamsUser: {
      const p = action.peyload;
      if (Array.isArray(p)) {
        return {
          ...newState,
          teamsUser: p,
        };
      }
      const nextTeams = handelSuggest(
        p.type,
        p.data,
        newState.teamsUser
      );
      const pi = p.pageInfo;
      let teamsUserHasNextPage = newState.teamsUserHasNextPage;
      let teamsUserEndCursor = newState.teamsUserEndCursor;
      if (p.type === "set") {
        if (pi !== undefined && pi !== null) {
          teamsUserHasNextPage = !!pi.hasNextPage;
          teamsUserEndCursor = pi.endCursor || null;
        } else {
          teamsUserHasNextPage = false;
          teamsUserEndCursor = null;
        }
      } else if (p.type === "push" && pi) {
        teamsUserHasNextPage = !!pi.hasNextPage;
        teamsUserEndCursor = pi.endCursor || null;
      }
      return {
        ...newState,
        teamsUser: nextTeams,
        teamsUserHasNextPage,
        teamsUserEndCursor,
      };
    }
    case Action.setTeamsJoin: {
      const p = action.peyload;
      if (Array.isArray(p)) {
        return {
          ...newState,
          teamsJoin: p,
        };
      }
      const nextJoin = handelSuggest(
        p.type,
        p.data,
        newState.teamsJoin
      );
      const pi = p.pageInfo;
      let teamsJoinHasNextPage = newState.teamsJoinHasNextPage;
      let teamsJoinEndCursor = newState.teamsJoinEndCursor;
      if (p.type === "set") {
        if (pi !== undefined && pi !== null) {
          teamsJoinHasNextPage = !!pi.hasNextPage;
          teamsJoinEndCursor = pi.endCursor || null;
        } else {
          teamsJoinHasNextPage = false;
          teamsJoinEndCursor = null;
        }
      } else if (p.type === "push" && pi) {
        teamsJoinHasNextPage = !!pi.hasNextPage;
        teamsJoinEndCursor = pi.endCursor || null;
      }
      return {
        ...newState,
        teamsJoin: nextJoin,
        teamsJoinHasNextPage,
        teamsJoinEndCursor,
      };
    }
    case Action.setFriendsUser: {
      const nextFriends = handelSuggest(
        action.peyload.type,
        action.peyload.data,
        newState.friendsUser
      );
      const pi = action.peyload.pageInfo;
      let friendsUserHasNextPage = newState.friendsUserHasNextPage;
      let friendsUserEndCursor = newState.friendsUserEndCursor;
      if (action.peyload.type === "set") {
        if (pi !== undefined && pi !== null) {
          friendsUserHasNextPage = !!pi.hasNextPage;
          friendsUserEndCursor = pi.endCursor || null;
        } else {
          friendsUserHasNextPage = false;
          friendsUserEndCursor = null;
        }
      } else if (action.peyload.type === "push" && pi) {
        friendsUserHasNextPage = !!pi.hasNextPage;
        friendsUserEndCursor = pi.endCursor || null;
      }
      return {
        ...newState,
        friendsUser: nextFriends,
        friendsUserHasNextPage,
        friendsUserEndCursor,
      };
    }
    case Action.setUser:
      return {
        ...newState,
        user: setUser(action.peyload.type, action.peyload.data, newState.user),
      };
    ///////////////////////////////////////
    case Action.setVerification:
      return {
        ...newState,
        verification: action.peyload,
      };
    ///////////////////////////////////////
    case Action.setMessage:
      return {
        ...newState,
        message: action.peyload,
      };
    default:
      return newState;
  }
};

export default reducer;
